import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, MessageCircle, Flame, ArrowRight, TrendingUp } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function TrendingStrip({ scope = "", title = "Trending in the community", limit = 8 }) {
  const { user } = useApp();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/trending", { params: { scope, limit } }).then(({ data }) => setItems(data.assets || [])).catch(() => setItems([]));
  }, [scope, limit]);

  const like = async (a) => {
    if (!user) { toast.error("Sign in to react."); return; }
    try {
      const { data } = await api.post(`/mint-market/${a.id}/like`);
      setItems((prev) => prev.map((x) => (x.id === a.id ? { ...x, liked: data.liked, likes: data.likes } : x)));
    } catch { /* ignore */ }
  };

  if (!items || items.length === 0) return null;
  return (
    <div className="mt-8" data-testid={`trending-${scope || "all"}`}>
      <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-brand mb-3"><Flame size={14} /> {title}</div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {items.map((a) => (
          <Link key={a.id} to={`/prosperity?asset=${a.id}`} className="rud-card rounded-2xl p-4 flex flex-col hover:border-brand/50 transition-colors cursor-pointer" data-testid={`trend-card-${a.id}`}>
            <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-brand">
              <span className="border border-brand/40 rounded-full px-2 py-0.5">{a.label || a.kind}</span>
              {a.trend_score > 0 && <span className="text-orange-400 flex items-center gap-0.5"><TrendingUp size={11} /> {a.trend_score}</span>}
            </div>
            <div className="text-sm font-medium mt-2 line-clamp-2">{a.title}</div>
            <p className="text-xs text-sec mt-1 line-clamp-2">{a.snippet}</p>
            <div className="flex items-center gap-3 mt-3 pt-3 border-t border-rud text-[11px] text-sec">
              <button data-testid={`trend-like-${a.id}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); like(a); }} className={`flex items-center gap-1 transition-colors ${a.liked ? "text-brand" : "hover:text-brand"}`}>
                <Heart size={13} fill={a.liked ? "currentColor" : "none"} /> {a.likes || 0}
              </button>
              <span className="flex items-center gap-1"><MessageCircle size={13} /> {a.comments || 0}</span>
              <span className="ml-auto text-[10px]">by {a.owner_name}</span>
              <span className="text-brand flex items-center gap-0.5">Use <ArrowRight size={11} /></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
